import {
  ChatBubbleLeftRightIcon,
  FolderOpenIcon,
  UserGroupIcon,
  UserIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import Card from "../components/shared/card";
import Typography from "../components/shared/typography";

export const HomePage = () => {
  const cards = [
    {
      label: "Chat",
      description: "Start chatting with Harper",
      icon: ChatBubbleLeftRightIcon,
      path: "/chat",
    },
    {
      label: "Contacts",
      description: "Manage your contacts",
      icon: UserGroupIcon,
      path: "/contacts",
    },
    {
      label: "Medical Records",
      description: "View your medical history",
      icon: FolderOpenIcon,
      path: "/medical-records",
    },
    {
      label: "Content",
      description: "Browse educational content",
      icon: DocumentTextIcon,
      path: "/content",
    },
    {
      label: "Account",
      description: "View account details",
      icon: UserIcon,
      path: "/account",
    },
  ];

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map(({ label, description, icon: Icon, path }) => (
          <Link key={label} to={path} className="block">
            <Card hoverEffect className="h-full">
              <Card.Body className="flex flex-col items-center text-center space-y-4 bg-cream-100">
                <Icon className="w-12 h-12 text-terracotta" />
                <Typography variant="h5" className="text-terracotta">
                  {label}
                </Typography>
                <Typography variant="body2" className="text-terracotta-900">
                  {description}
                </Typography>
              </Card.Body>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
